import { useQuery } from '@tanstack/react-query'
import { baseUrl } from 'api/config'
import axios from 'axios'

export const ITEM_PK_SK_KEY = (PK: string, SK: string) => ['item', PK, SK] as const

export const getItemByPkSk = async (PK: string, SK: string) => {
  const { data } = await axios.get(`${baseUrl}/aws/organizations_table/item/${PK}/${SK}`)
  return data
}

export const useItemByPkSk = (PK?: string, SK?: string, enabled = true) => {
  return useQuery({
    queryKey: ITEM_PK_SK_KEY(PK!, SK!),
    queryFn: () => getItemByPkSk(PK!, SK!),
    enabled: !!PK && !!SK && enabled,
    staleTime: 30 * 1000,
    gcTime: 5 * 60 * 1000,
  })
}
